import { Injectable } from '@angular/core';
import * as i18nIsoCountries from 'i18n-iso-countries';

declare const require: any;

@Injectable()
export class CountryService {
  constructor() {
    const countryData = require('i18n-iso-countries/langs/en.json');
    i18nIsoCountries.registerLocale(countryData);
  }

  getCountryName(isoCode: string): string {
    const locale = 'en';
    return i18nIsoCountries.getNames(locale)[isoCode];
  }
}
